// Re-export domain types for organization core
import { api as registrationApi } from '@repo/api-kit/registration';

export type ApiOrganization = registrationApi.organizations.firstparty.v5.ApiOrganization;
export type ApiOrganizationStatus =
  registrationApi.organizations.firstparty.v5.ApiOrganizationStatus;
export type ApiSuspensionReason = registrationApi.organizations.firstparty.v5.ApiSuspensionReason;

export const ApiOrganizationStatus =
  registrationApi.organizations.firstparty.v5.ApiOrganizationStatus;
export const ApiSuspensionReason = registrationApi.organizations.firstparty.v5.ApiSuspensionReason;
